import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ListResult } from '../api/core/list-result';
import { User, AADUserProfile, UserProfile } from '../api/user/user';
import { BACKEND_URL } from '../app.config';
import { Role } from '../api/role/role';
import { FavoriteReportItem } from '../api/report/favoritereport';
import { EntityType } from '../api/enum';
@Injectable()
export class UserService {
  constructor(private readonly http: HttpClient, @Inject(BACKEND_URL) private readonly baseUrl: string) {}

  getList(filter: string, sorting: string, skipCount: number, maxResultCount: number): Observable<ListResult<User>> {
    return this.http.get<ListResult<User>>(this.baseUrl + '/api/identity/users', {
      params: {
        filter,
        sorting,
        skipCount,
        maxResultCount,
      },
    });
  }

  getUser(id: string): Observable<User> {
    return this.http.get<User>(this.baseUrl + '/api/identity/users/' + id);
  }

  getUserRoles(id: string): Observable<{ items: Role[] }> {
    return this.http.get<{ items: Role[] }>(this.baseUrl + `/api/identity/users/${id}/roles`);
  }

  addUser(user: User): Observable<User> {
    return this.http.post<User>(this.baseUrl + '/api/identity/users', user);
  }

   getUserProfile(id: string): Observable<UserProfile> {
    return this.http.get<UserProfile>(this.baseUrl + '/api/app/user/' + id);
  }

   updateUserProfile(id: string, user: UserProfile): Observable<UserProfile> {
    return this.http.put<UserProfile>(this.baseUrl + '/api/app/user/' + id, user);
  }
 
  updateUser(id: string, user: User): Observable<User> {
    return this.http.put<User>(this.baseUrl + '/api/identity/users/' + id, user);
  }

  deleteUser(id: string): Observable<void> {
    return this.http.delete<void>(this.baseUrl + '/api/identity/users/' + id);
  }

  /*validateAADMail(mail: string): Observable<AADUserProfile> {
    return this.http.get<AADUserProfile>(this.baseUrl + '/api/app/user/aad-user?email=' + mail);
  }*/

  addADUser(mail: string): Observable<User> {
    return this.http.post<User>(this.baseUrl + '/api/app/user', {
      mail: mail,
    });
  }

  favorite(entityId: string, entityType: number): Observable<boolean> {
    return this.http.put<boolean>(`${this.baseUrl}/api/app/user/my/favorites`, {
      entityId: entityId,
      entityType: entityType,
    });
  }

  getFavoriteReports(): Observable<FavoriteReportItem[]> {
    return this.http.get<FavoriteReportItem[]>(this.baseUrl + '/api/app/user/my/favorites', {
      params: {
        entityType: EntityType.Report,
        maxCount: 1000,
      },
    });
  }
    getUserFitlerList(filter: string) {
      return this.http.post<AADUserProfile[]>(this.baseUrl + "/api/app/user/search-aad-users", null,{
        params: {
          filter: filter ?? '',
          top: '10',

        }
      });
    }
}
